<style>
h3{
    margin: 10px 0;
  }
</style>
<template>
  <div class="sendMsg-box">
    <p class="title">api文档&nbsp;&nbsp;<strong>[ 指定模板单发/群发送短信（模板参数一致）]</strong></p>
    <div class=WordSection1 style='layout-grid:15.6pt'>
      <h3>接口描述</h3>
          <h3>功能描述</h3>
          <p> 给用户群发通知类或营销类短信。 <br>手机号码需全部为国内或者海外手机号码</p>
          <h3>示例</h3>
          <p>POST：https://sms.jpark.vip/lfnsmsplatform/api/send/sendMsgByParamsTheSame</p>
          <h3>请求参数示例</h3>
<pre style='width:800px;margin-bottom:18.0pt;background:#F2F2F2'><code><span lang=EN-US
style='font-size:10.5pt;font-family:Consolas;color:#333333;background:#F2F2F2'>{</span></code><code><span lang=EN-US
style='font-size:10.5pt;font-family:Consolas;color:#333333;background:#F2F2F2'><br><br>&nbsp;&nbsp;&nbsp;</span></code><span
lang=EN-US style='font-size:10.5pt;font-family:Consolas;color:#333333;
background:#F2F2F2'>&quot;</span><span lang=EN-US style='font-size:9.0pt;
font-family:"Helvetica","sans-serif";color:#505050;background:white'>authorization</span><span
lang=EN-US style='font-size:10.5pt;font-family:Consolas;color:#333333;
background:#F2F2F2'>&quot;<code><span style='font-family:Consolas'>: </span></code></span><span
lang=EN-US style='font-size:10.5pt;font-family:Consolas;color:#DD1144;
background:#F2F2F2'>&quot;&quot;</span><code><span lang=EN-US style='font-size:
10.5pt;font-family:Consolas;color:#333333;background:#F2F2F2'>,</span></code><code><span lang=EN-US
style='font-size:10.5pt;font-family:Consolas;color:#333333;background:#F2F2F2'><br><br>&nbsp;&nbsp;&nbsp;</span></code><span
lang=EN-US style='font-size:10.5pt;font-family:Consolas;color:#333333;
background:#F2F2F2'>&quot;</span><span lang=EN-US style='font-size:9.0pt;
font-family:"Helvetica","sans-serif";color:#505050;background:white'>mouldSign</span><span
lang=EN-US style='font-size:10.5pt;font-family:Consolas;color:#333333;
background:#F2F2F2'>&quot;<code><span style='font-family:Consolas'>: </span></code></span><span
lang=EN-US style='font-size:10.5pt;font-family:Consolas;color:#DD1144;
background:#F2F2F2'>&quot;</span><span lang=EN-US style='font-size:10.5pt;
font-family:Consolas;color:#DD1144;background:#F2F2F2'>1449e6b5-eefe-4801-b293-b9b0f79e0111</span><span
lang=EN-US style='font-size:10.5pt;font-family:Consolas;color:#DD1144;
background:#F2F2F2'>&quot;</span><code><span lang=EN-US style='font-size:10.5pt;
font-family:Consolas;color:#333333;background:#F2F2F2'>,</span></code><code><span lang=EN-US
style='font-size:10.5pt;font-family:Consolas;color:#333333;background:#F2F2F2'><br><br>&nbsp;&nbsp;&nbsp;</span></code><span
lang=EN-US style='font-size:10.5pt;font-family:Consolas;color:#333333;
background:#F2F2F2'>&quot;params&quot;<code><span style='font-family:Consolas'>: [</span></code></span><code><span lang=EN-US
style='font-size:10.5pt;font-family:Consolas;color:#333333;background:#F2F2F2'></span></code><span
lang=EN-US style='font-size:10.5pt;font-family:Consolas;color:#DD1144;
background:#F2F2F2'>&quot;</span><span style='font-size:9.0pt;font-family:"Helvetica","sans-serif";
color:#DD1144;background:white'>登录</span><span lang=EN-US style='font-size:
10.5pt;font-family:Consolas;color:#DD1144;background:#F2F2F2'>&quot;</span><code><span
lang=EN-US style='font-size:10.5pt;font-family:Consolas;color:#333333;
background:#F2F2F2'>,</span></code><code><span lang=EN-US style='font-size:10.5pt;font-family:
Consolas;color:#333333;background:#F2F2F2'></span></code><span
lang=EN-US style='font-size:10.5pt;font-family:Consolas;color:#DD1144;
background:#F2F2F2'>&quot;1234&quot;</span><code><span lang=EN-US
style='font-size:10.5pt;font-family:Consolas;color:#333333;background:#F2F2F2'>,</span></code><code><span lang=EN-US
style='font-size:10.5pt;font-family:Consolas;color:#333333;background:#F2F2F2'></span></code><span
lang=EN-US style='font-size:10.5pt;font-family:Consolas;color:#DD1144;
background:#F2F2F2'>&quot;</span><span lang=EN-US style='font-size:9.0pt;
font-family:"Helvetica","sans-serif";color:#DD1144;background:white'>2</span><span
lang=EN-US style='font-size:10.5pt;font-family:Consolas;color:#DD1144;
background:#F2F2F2'>&quot;</span><code><span lang=EN-US style='font-size:10.5pt;font-family:
Consolas;color:#333333;background:#F2F2F2'>],</span></code><code><span lang=EN-US
style='font-size:10.5pt;font-family:Consolas;color:#333333;background:#F2F2F2'><br><br>&nbsp;&nbsp;&nbsp;</span></code><span
lang=EN-US style='font-size:10.5pt;font-family:Consolas;color:#333333;
background:#F2F2F2'>&quot;</span><span lang=EN-US style='font-size:9.0pt;
font-family:"Helvetica","sans-serif";color:#505050;background:white'>sign</span><span
lang=EN-US style='font-size:10.5pt;font-family:Consolas;color:#333333;
background:#F2F2F2'>&quot;<code><span style='font-family:Consolas'>: </span></code></span><span
lang=EN-US style='font-size:10.5pt;font-family:Consolas;color:#DD1144;
background:#F2F2F2'>&quot;</span><span style='font-size:9.0pt;font-family:"Helvetica","sans-serif";
color:#DD1144;background:white'>佳峰逸珠链科技</span><span lang=EN-US
style='font-size:10.5pt;font-family:Consolas;color:#DD1144;background:#F2F2F2'>&quot;</span><code><span
lang=EN-US style='font-size:10.5pt;font-family:Consolas;color:#333333;
background:#F2F2F2'>,</span></code><span lang=EN-US style='font-size:10.5pt;
font-family:Consolas;color:#333333;background:#F2F2F2'><br><br>&nbsp;&nbsp;&nbsp;&quot;</span><span
lang=EN-US style='font-size:9.0pt;font-family:"Helvetica","sans-serif";
color:#505050;background:white'>userPhone</span><span lang=EN-US
style='font-size:10.5pt;font-family:Consolas;color:#333333;background:#F2F2F2'>&quot;<code><span
style='font-family:Consolas'>: [</span></code></span><span lang=EN-US
style='font-size:10.5pt;font-family:Consolas;color:#DD1144;background:#F2F2F2'>&quot;13788888888&quot;</span><code><span
lang=EN-US style='font-size:10.5pt;font-family:Consolas;color:#333333;
background:#F2F2F2'>,</span></code><span lang=EN-US style='font-size:10.5pt;
font-family:Consolas;color:#DD1144;background:#F2F2F2'>&quot;13788888889&quot;</span><code><span
lang=EN-US style='font-size:10.5pt;font-family:Consolas;color:#333333;
background:#F2F2F2'>],</span></code><span lang=EN-US style='font-size:10.5pt;
font-family:Consolas;color:#333333;background:#F2F2F2'><br><br>&nbsp;&nbsp;&nbsp;&quot;</span><span
lang=EN-US style='font-size:9.0pt;font-family:"Helvetica","sans-serif";
color:#505050;background:white'>user</span><span lang=EN-US style='font-size:
9.0pt;font-family:"Helvetica","sans-serif";color:#505050;background:white'>Name</span><span
lang=EN-US style='font-size:10.5pt;font-family:Consolas;color:#333333;
background:#F2F2F2'>&quot;<code><span style='font-family:Consolas'>: </span></code>&quot;</span><span
lang=EN-US style='font-size:9.0pt;font-family:"Helvetica","sans-serif";
color:#DD1144;background:white'>test</span><span lang=EN-US style='font-size:
10.5pt;font-family:Consolas;color:#333333;background:#F2F2F2'>&quot;</span><code><span
lang=EN-US style='font-size:10.5pt;font-family:Consolas;color:#333333;
background:#F2F2F2'><br><br>}</span></code></pre>

<p style='margin-bottom:7.5pt;background:white'><span lang=EN-US
style='font-size:9.0pt;font-family:"Helvetica","sans-serif";color:#505050;
background:white'>&nbsp;</span></p>

<table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0 width=800
 style='background:white;border-collapse:collapse;border:none'>
 <thead>
  <tr>
   <td width=95 style='width:71.1pt;border:solid #D9D9D9 1.0pt;background:#F2F2F2;
   padding:6.0pt 9.75pt 6.0pt 9.75pt'>
   <p class=MsoNormal align=left style='text-align:left'><span
   style='font-family:"Arial","sans-serif";color:#333333'>参数</span></p>
   </td>
   <td width=57 style='width:42.65pt;border:solid #D9D9D9 1.0pt;border-left:
   none;background:#F2F2F2;padding:6.0pt 9.75pt 6.0pt 9.75pt'>
   <p class=MsoNormal align=left style='text-align:left'><span
   style='font-family:"Arial","sans-serif";color:#333333'>必选</span></p>
   </td>
   <td width=77 style='width:58.0pt;border:solid #D9D9D9 1.0pt;border-left:
   none;background:#F2F2F2;padding:6.0pt 9.75pt 6.0pt 9.75pt'>
   <p class=MsoNormal align=left style='text-align:left'><span
   style='font-family:"Arial","sans-serif";color:#333333'>类型</span></p>
   </td>
   <td width=661 style='width:495.6pt;border:solid #D9D9D9 1.0pt;border-left:
   none;background:#F2F2F2;padding:6.0pt 9.75pt 6.0pt 9.75pt'>
   <p class=MsoNormal align=left style='text-align:left'><span
   style='font-family:"Arial","sans-serif";color:#333333'>描述</span></p>
   </td>
  </tr>
 </thead>
 <tr>
  <td width=95 style='width:71.1pt;border:solid #D9D9D9 1.0pt;border-top:none;
  padding:6.0pt 9.75pt 6.0pt 9.75pt'>
  <p class=MsoNormal align=left style='text-align:left'><span lang=EN-US
  style='font-size:9.0pt;font-family:"Helvetica","sans-serif";color:#505050;
  background:white'>authorization</span></p>
  </td>
  <td width=57 style='width:42.65pt;border-top:none;border-left:none;
  border-bottom:solid #D9D9D9 1.0pt;border-right:solid #D9D9D9 1.0pt;
  padding:6.0pt 9.75pt 6.0pt 9.75pt'>
  <p class=MsoNormal align=left style='text-align:left'><span style='font-family:
  "Arial","sans-serif";color:#333333'>是</span></p>
  </td>
  <td width=77 style='width:58.0pt;border-top:none;border-left:none;border-bottom:
  solid #D9D9D9 1.0pt;border-right:solid #D9D9D9 1.0pt;padding:6.0pt 9.75pt 6.0pt 9.75pt'>
  <p class=MsoNormal align=left style='text-align:left'><span lang=EN-US
  style='font-family:"Arial","sans-serif";color:#333333'>string</span></p>
  </td>
  <td width=661 style='width:495.6pt;border-top:none;border-left:none;
  border-bottom:solid #D9D9D9 1.0pt;border-right:solid #D9D9D9 1.0pt;
  padding:6.0pt 9.75pt 6.0pt 9.75pt'>
  <p class=MsoNormal align=left style='text-align:left'><span style='font-family:
  "Arial","sans-serif";color:#333333'>用户认证信息<span lang=EN-US>,</span>具体计算方式见下注</span></p>
  </td>
 </tr>
 <tr>
  <td width=95 style='width:71.1pt;border:solid #D9D9D9 1.0pt;border-top:none;
  padding:6.0pt 9.75pt 6.0pt 9.75pt'>
  <p class=MsoNormal align=left style='text-align:left'><span lang=EN-US
  style='font-size:9.0pt;font-family:"Helvetica","sans-serif";color:#505050;
  background:white'>mouldSign</span></p>
  </td>
  <td width=57 style='width:42.65pt;border-top:none;border-left:none;
  border-bottom:solid #D9D9D9 1.0pt;border-right:solid #D9D9D9 1.0pt;
  padding:6.0pt 9.75pt 6.0pt 9.75pt'>
  <p class=MsoNormal align=left style='text-align:left'><span style='font-family:
  "Arial","sans-serif";color:#333333'>是</span></p>
  </td>
  <td width=77 style='width:58.0pt;border-top:none;border-left:none;border-bottom:
  solid #D9D9D9 1.0pt;border-right:solid #D9D9D9 1.0pt;padding:6.0pt 9.75pt 6.0pt 9.75pt'>
  <p class=MsoNormal align=left style='text-align:left'><span lang=EN-US
  style='font-family:"Arial","sans-serif";color:#333333'>string</span></p>
  </td>
  <td width=661 style='width:495.6pt;border-top:none;border-left:none;
  border-bottom:solid #D9D9D9 1.0pt;border-right:solid #D9D9D9 1.0pt;
  padding:6.0pt 9.75pt 6.0pt 9.75pt'>
  <p class=MsoNormal align=left style='text-align:left'><span style='font-family:
  宋体;color:#333333'>短信模板编号</span></p>
  </td>
 </tr>
 <tr>
  <td width=95 style='width:71.1pt;border:solid #D9D9D9 1.0pt;border-top:none;
  padding:6.0pt 9.75pt 6.0pt 9.75pt'>
  <p class=MsoNormal align=left style='text-align:left'><span lang=EN-US
  style='font-family:"Arial","sans-serif";color:#333333'>params</span></p>
  </td>
  <td width=57 style='width:42.65pt;border-top:none;border-left:none;
  border-bottom:solid #D9D9D9 1.0pt;border-right:solid #D9D9D9 1.0pt;
  padding:6.0pt 9.75pt 6.0pt 9.75pt'>
  <p class=MsoNormal align=left style='text-align:left'><span style='font-family:
  "Arial","sans-serif";color:#333333'>是</span></p>
  </td>
  <td width=77 style='width:58.0pt;border-top:none;border-left:none;border-bottom:
  solid #D9D9D9 1.0pt;border-right:solid #D9D9D9 1.0pt;padding:6.0pt 9.75pt 6.0pt 9.75pt'>
  <p class=MsoNormal align=left style='text-align:left'><span lang=EN-US
  style='font-family:"Arial","sans-serif";color:#333333'>array</span></p>
  </td>
  <td width=661 style='width:495.6pt;border-top:none;border-left:none;
  border-bottom:solid #D9D9D9 1.0pt;border-right:solid #D9D9D9 1.0pt;
  padding:6.0pt 9.75pt 6.0pt 9.75pt'>
  <p class=MsoNormal align=left style='text-align:left'><span style='font-family:
  "Arial","sans-serif";color:#333333'>模板参数，若模板没有参数，请提供为空数组</span></p>
  </td>
 </tr>
 <tr>
  <td width=95 style='width:71.1pt;border:solid #D9D9D9 1.0pt;border-top:none;
  padding:6.0pt 9.75pt 6.0pt 9.75pt'>
  <p class=MsoNormal align=left style='text-align:left'><span lang=EN-US
  style='font-family:"Arial","sans-serif";color:#333333'>sign</span></p>
  </td>
  <td width=57 style='width:42.65pt;border-top:none;border-left:none;
  border-bottom:solid #D9D9D9 1.0pt;border-right:solid #D9D9D9 1.0pt;
  padding:6.0pt 9.75pt 6.0pt 9.75pt'>
  <p class=MsoNormal align=left style='text-align:left'><span style='font-family:
  "Arial","sans-serif";color:#333333'>是</span></p>
  </td>
  <td width=77 style='width:58.0pt;border-top:none;border-left:none;border-bottom:
  solid #D9D9D9 1.0pt;border-right:solid #D9D9D9 1.0pt;padding:6.0pt 9.75pt 6.0pt 9.75pt'>
  <p class=MsoNormal align=left style='text-align:left'><span lang=EN-US
  style='font-family:"Arial","sans-serif";color:#333333'>string</span></p>
  </td>
  <td width=661 style='width:495.6pt;border-top:none;border-left:none;
  border-bottom:solid #D9D9D9 1.0pt;border-right:solid #D9D9D9 1.0pt;
  padding:6.0pt 9.75pt 6.0pt 9.75pt'>
  <p class=MsoNormal align=left style='text-align:left'><span style='font-family:
  "Arial","sans-serif";color:#333333'>短信签名</span></p>
  </td>
 </tr>
 <tr>
  <td width=95 style='width:71.1pt;border:solid #D9D9D9 1.0pt;border-top:none;
  padding:6.0pt 9.75pt 6.0pt 9.75pt'>
  <p class=MsoNormal align=left style='text-align:left'><span lang=EN-US
  style='font-size:9.0pt;font-family:"Helvetica","sans-serif";color:#505050;
  background:white'>userPhone</span></p>
  </td>
  <td width=57 style='width:42.65pt;border-top:none;border-left:none;
  border-bottom:solid #D9D9D9 1.0pt;border-right:solid #D9D9D9 1.0pt;
  padding:6.0pt 9.75pt 6.0pt 9.75pt'>
  <p class=MsoNormal align=left style='text-align:left'><span style='font-family:
  "Arial","sans-serif";color:#333333'>是</span></p>
  </td>
  <td width=77 style='width:58.0pt;border-top:none;border-left:none;border-bottom:
  solid #D9D9D9 1.0pt;border-right:solid #D9D9D9 1.0pt;padding:6.0pt 9.75pt 6.0pt 9.75pt'>
  <p class=MsoNormal align=left style='text-align:left'><span lang=EN-US
  style='font-family:"Arial","sans-serif";color:#333333'>array</span></p>
  </td>
  <td width=661 style='width:495.6pt;border-top:none;border-left:none;
  border-bottom:solid #D9D9D9 1.0pt;border-right:solid #D9D9D9 1.0pt;
  padding:6.0pt 9.75pt 6.0pt 9.75pt'>
  <p class=MsoNormal align=left style='text-align:left'><span style='font-family:
  "Arial","sans-serif";color:#333333'>电话号码数组</span></p>
  </td>
 </tr>
 <tr>
  <td width=95 style='width:71.1pt;border:solid #D9D9D9 1.0pt;border-top:none;
  padding:6.0pt 9.75pt 6.0pt 9.75pt'>
  <p class=MsoNormal align=left style='text-align:left'><span lang=EN-US
  style='font-size:9.0pt;font-family:"Helvetica","sans-serif";color:#505050;
  background:white'>user</span><span lang=EN-US style='font-size:9.0pt;
  font-family:"Helvetica","sans-serif";color:#505050;background:white'>Name</span></p>
  </td>
  <td width=57 style='width:42.65pt;border-top:none;border-left:none;
  border-bottom:solid #D9D9D9 1.0pt;border-right:solid #D9D9D9 1.0pt;
  padding:6.0pt 9.75pt 6.0pt 9.75pt'>
  <p class=MsoNormal align=left style='text-align:left'><span style='font-family:
  "Arial","sans-serif";color:#333333'>是</span></p>
  </td>
  <td width=77 style='width:58.0pt;border-top:none;border-left:none;border-bottom:
  solid #D9D9D9 1.0pt;border-right:solid #D9D9D9 1.0pt;padding:6.0pt 9.75pt 6.0pt 9.75pt'>
  <p class=MsoNormal align=left style='text-align:left'><span lang=EN-US
  style='font-family:"Arial","sans-serif";color:#333333'>string</span></p>
  </td>
  <td width=661 style='width:495.6pt;border-top:none;border-left:none;
  border-bottom:solid #D9D9D9 1.0pt;border-right:solid #D9D9D9 1.0pt;
  padding:6.0pt 9.75pt 6.0pt 9.75pt'>
  <p class=MsoNormal align=left style='text-align:left'><span style='font-family:
  "Arial","sans-serif";color:#333333'>短信平台用户名</span></p>
  </td>
 </tr>
</table>
 <p style='margin-bottom:7.5pt;background:white'><span lang=EN-US
  style='font-size:10.5pt;font-family:"Arial","sans-serif";color:#333333;
  background:white'>&nbsp;</span></p>

  <p style='margin-bottom:7.5pt;background:white'><strong><span
  style='font-size:12.0pt;font-family:"Arial","sans-serif";color:red;background:white'>注</span></strong><span
  lang=EN-US style='font-size:10.5pt;font-family:"Arial","sans-serif";color:#333333;
  background:white'>:</span></p>

  <p class=MsoNormal style='margin-left:1cm;text-indent:-18.0pt'><span
  lang=EN-US style='font-size:12.0pt'>1.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
  </span></span><span lang=EN-US style='font-size:12.0pt;font-family:"Helvetica","sans-serif";
  color:#DD1144;background:white'>mouldSign</span><span lang=EN-US
  style='font-family:"Arial","sans-serif";color:#333333;background:white'>&nbsp;</span><span
  style='font-family:"Arial","sans-serif";color:#333333;background:white'>字段需填写审核通过的模板
  </span><span style='font-family:宋体;color:#333333;background:white'>编号</span><span
  style='font-family:"Arial","sans-serif";color:#333333;background:white'>，<span
  lang=EN-US><br>
  </span>假如模版 </span><span style='font-family:宋体;color:#333333;background:white'>编号</span><span
  style='font-family:"Arial","sans-serif";color:#333333;background:white'> 对应的模板内容为：<span
  lang=EN-US>&nbsp;</span></span><code><span style='font-family:Consolas;
  color:#333333;background:white'>您的<span lang=EN-US>{1}</span>是<span lang=EN-US>{2}</span>，请于<span
  lang=EN-US>{3}</span>分钟内填写。如非本人操作，请忽略本短信。</span><br></code><span lang=EN-US
  style='font-family:"Arial","sans-serif";color:#333333;background:white'></span><span
  style='font-family:"Arial","sans-serif";color:#333333;background:white'>则上面请求参数组合后下发的内容为：<span
  lang=EN-US>&nbsp;</span></span><code><span style='font-family:Consolas;
  color:#333333;background:white'>【</span></code><span style='font-size:9.0pt;
  font-family:"Helvetica","sans-serif";color:#505050;background:white'>佳峰逸珠链科技</span><code><span
  style='font-family:Consolas;color:#333333;background:white'>】您的验证码是<span
  lang=EN-US>1234</span>，请于<span lang=EN-US>4</span>分钟内填写。如非本人操作，请忽略本短信</span></code><span
  lang=EN-US style='font-family:"Arial","sans-serif";color:#333333;background:
  white'>&nbsp;</span><span style='font-family:"Arial","sans-serif";color:#333333;
  background:white'>。<span lang=EN-US><br>
  </span>如您有多个短信签名，请将需要的短信签名填入<span lang=EN-US>&nbsp;</span></span><code><span
  lang=EN-US style='font-family:Consolas;color:#333333;background:white'>sign</span></code><span
  lang=EN-US style='font-family:"Arial","sans-serif";color:#333333;background:
  white'>&nbsp;</span><span style='font-family:"Arial","sans-serif";color:#333333;
  background:white'>字段，例如您有<span lang=EN-US>&nbsp;</span></span><span
  style='font-family:"宋体","sans-serif";color:red;
  background:white'>佳峰逸珠链</span><span lang=EN-US style='font-family:"Arial","sans-serif";
  color:#333333;background:white'>&nbsp;</span><span style='font-family:"Arial","sans-serif";
  color:#333333;background:white'>和</span><span style='font-family:宋体;color:red;
  background:white'>逸珠链科技</span><span lang=EN-US style='font-family:"Arial","sans-serif";
  color:#333333;background:white'>&nbsp;</span><span style='font-family:"Arial","sans-serif";
  color:#333333;background:white'>两个签名，<br>但想以<span lang=EN-US>&nbsp;</span></span><span
  style='font-family:宋体;color:#333333;background:white'>逸珠链科技</span><span
  lang=EN-US style='font-family:"Arial","sans-serif";color:#333333;background:
  white'>&nbsp;</span><span style='font-family:"Arial","sans-serif";color:#333333;
  background:white'>签名发送短信，则<span lang=EN-US>&nbsp;</span></span><code><span
  lang=EN-US style='font-family:Consolas;color:#333333;background:white'>sign</span></code><span
  lang=EN-US style='font-family:"Arial","sans-serif";color:#333333;background:
  white'>&nbsp;</span><span style='font-family:"Arial","sans-serif";color:#333333;
  background:white'>字段可赋值为：</span><span style='font-family:宋体;color:#333333;
  background:white'>逸珠链科技</span><span lang=EN-US style='font-family:"Arial","sans-serif";
  color:#333333;background:white'>&nbsp;</span><span style='font-family:"Arial","sans-serif";
  color:#333333;background:white'>。</span></p>

  <p class=MsoNormal style='margin-left:1cm;text-indent:-18.0pt'><span
  lang=EN-US style='font-size:12.0pt'>2.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
  </span></span><span lang=EN-US style='font-size:12.0pt;font-family:"Helvetica","sans-serif";
  color:#DD1144;background:white'>authorization</span><span lang=EN-US
  style='font-family:"Arial","sans-serif";color:#333333;background:white'>&nbsp;</span><span
  style='font-family:"Arial","sans-serif";color:#333333;background:white'>字段是根据jwt生成的认证签名，密钥请到用户中心获取，jwt信息包含用户的登录密码和需要调用的api地址。
  </span><span style='font-family:宋体;color:#333333;background:white'><br>密码需要在加密的基础上进行AES加密（密钥请到用户中心获取,同jwt密钥）。</span><span
  lang=EN-US><br></span>
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  <pre style='width:760px;margin-bottom:18.0pt;
  background:#F2F2F2'><span lang=EN-US style='font-size:10.5pt;font-family:"Arial","sans-serif";
  color:#333333;'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;String secrect = &quot;</span><span
  lang=EN-US style='font-size:10.5pt;font-family:"Arial","sans-serif";color:#333333;
  '>your secrect </span><span lang=EN-US style='color:#333333;
  '>&quot;;</span><span lang=EN-US style='font-size:10.5pt;font-family:"Arial","sans-serif";
  color:#333333;'><br><br>String passwordAES = AESUtil.encryption(your md5 password, secrect);</span><span lang=EN-US
  style='font-size:10.5pt;font-family:"Arial","sans-serif";color:#333333;
  '><br><br>Map&lt;String,Object&gt; claims = new HashMap&lt;&gt;();</span><span lang=EN-US
  style='font-size:10.5pt;font-family:"Arial","sans-serif";color:#333333;
  '><br><br>claims.put(&quot;password&quot;,passwordAES);</span><span lang=EN-US
  style='font-size:10.5pt;font-family:"Arial","sans-serif";color:#333333;
  '><br><br>claims.put(&quot;requestURI&quot;,&quot;</span><span
  class=MsoHyperlink><span lang=EN-US style='font-size:9.0pt;font-family:"Helvetica","sans-serif";
  '>/lfnsmsplatform/api/send/sendMsgByParamsTheSame</span></span><span
  lang=EN-US style='font-size:10.5pt;font-family:"Arial","sans-serif";color:#333333;
  '>&quot;);</span><span lang=EN-US style='font-size:10.5pt;font-family:"Arial","sans-serif";
  color:#333333;'><br><br>String authorization = JwtUtils.generateToken(secrect,1,claims);</span><span lang=EN-US
  style='font-size:10.5pt;font-family:"Arial","sans-serif";color:#333333;
  '>&nbsp;</span></pre>

  <h4 style='margin-top:28.5pt;margin-right:0cm;margin-bottom:15.0pt;margin-left:
  0cm;background:white'><span style='font-size:12.0pt;font-family:"Arial","sans-serif";color:#333333;
  background:white'>响应参数</span></h4>

  <pre style='width:800px;margin-bottom:18.0pt;background:#F2F2F2'><code><span lang=EN-US
  style='font-size:10.5pt;font-family:Consolas;color:#333333;background:#F2F2F2'>{</span></code><code><span lang=EN-US
  style='font-size:10.5pt;font-family:Consolas;color:#333333;background:#F2F2F2'><br><br>&nbsp;&nbsp;&nbsp;</span></code><span
  lang=EN-US style='font-size:10.5pt;font-family:Consolas;color:#333333;
  background:#F2F2F2'>&quot;</span><span lang=EN-US style='font-size:9.0pt;
  font-family:"Helvetica","sans-serif";color:#505050;background:white'>status</span><span
  lang=EN-US style='font-size:10.5pt;font-family:Consolas;color:#333333;
  background:#F2F2F2'>&quot;<code><span style='font-family:Consolas'>: </span></code></span><span
  lang=EN-US style='font-size:10.5pt;font-family:Consolas;color:#DD1144;
  background:#F2F2F2'>&quot;success&quot;</span><code><span lang=EN-US
  style='font-size:10.5pt;font-family:Consolas;color:#333333;background:#F2F2F2'>,<br><br>&nbsp;&nbsp;&nbsp;</span></code><span
  lang=EN-US style='font-size:10.5pt;font-family:Consolas;color:#333333;
  background:#F2F2F2'>&quot;</span><span lang=EN-US style='font-size:9.0pt;
  font-family:"Helvetica","sans-serif";color:#505050;background:white'>msg</span><span
  lang=EN-US style='font-size:10.5pt;font-family:Consolas;color:#333333;
  background:#F2F2F2'>&quot;<code><span style='font-family:Consolas'>: </span></code></span><span
  lang=EN-US style='font-size:10.5pt;font-family:Consolas;color:#DD1144;
  background:#F2F2F2'>&quot;</span><span style='font-size:10.5pt;color:#DD1144;
  background:#F2F2F2'>处理成功</span><span lang=EN-US style='font-size:10.5pt;
  font-family:Consolas;color:#DD1144;background:#F2F2F2'>&quot;</span><code><span
  lang=EN-US style='font-size:10.5pt;font-family:Consolas;color:#333333;
  background:#F2F2F2'></span></code><code><span lang=EN-US style='font-size:10.5pt;font-family:
  Consolas;color:#333333;background:#F2F2F2'> <br><br>}</span></code></pre>

  <p class=MsoNormal><span lang=EN-US>&nbsp;</span></p>

  <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0 width=800
  style='background:white;border-collapse:collapse;border:none'>
  <thead>
    <tr>
    <td width=102 style='width:76.3pt;border:solid #D9D9D9 1.0pt;background:
    #F2F2F2;padding:6.0pt 9.75pt 6.0pt 9.75pt'>
    <p class=MsoNormal align=left style='text-align:left'><span
    style='font-family:"Arial","sans-serif";color:#333333'>参数</span></p>
    </td>
    <td width=92 style='width:69.3pt;border:solid #D9D9D9 1.0pt;border-left:
    none;background:#F2F2F2;padding:6.0pt 9.75pt 6.0pt 9.75pt'>
    <p class=MsoNormal align=left style='text-align:left'><span
    style='font-family:"Arial","sans-serif";color:#333333'>必选</span></p>
    </td>
    <td width=107 style='width:80.25pt;border:solid #D9D9D9 1.0pt;border-left:
    none;background:#F2F2F2;padding:6.0pt 9.75pt 6.0pt 9.75pt'>
    <p class=MsoNormal align=left style='text-align:left'><span
    style='font-family:"Arial","sans-serif";color:#333333'>类型</span></p>
    </td>
    <td width=589 style='width:441.55pt;border:solid #D9D9D9 1.0pt;border-left:
    none;background:#F2F2F2;padding:6.0pt 9.75pt 6.0pt 9.75pt'>
    <p class=MsoNormal align=left style='text-align:left'><span
    style='font-family:"Arial","sans-serif";color:#333333'>描述</span></p>
    </td>
    </tr>
  </thead>
  <tr>
    <td width=102 style='width:76.3pt;border:solid #D9D9D9 1.0pt;border-top:none;
    padding:6.0pt 9.75pt 6.0pt 9.75pt'>
    <p class=MsoNormal align=left style='text-align:left'><span lang=EN-US
    style='font-size:9.0pt;font-family:"Helvetica","sans-serif";color:#505050;
    background:white'>status</span></p>
    </td>
    <td width=92 style='width:69.3pt;border-top:none;border-left:none;border-bottom:
    solid #D9D9D9 1.0pt;border-right:solid #D9D9D9 1.0pt;padding:6.0pt 9.75pt 6.0pt 9.75pt'>
    <p class=MsoNormal align=left style='text-align:left'><span style='font-family:
    "Arial","sans-serif";color:#333333'>是</span></p>
    </td>
    <td width=107 style='width:80.25pt;border-top:none;border-left:none;
    border-bottom:solid #D9D9D9 1.0pt;border-right:solid #D9D9D9 1.0pt;
    padding:6.0pt 9.75pt 6.0pt 9.75pt'>
    <p class=MsoNormal align=left style='text-align:left'><span lang=EN-US
    style='font-family:"Arial","sans-serif";color:#333333'>String</span></p>
    </td>
    <td width=589 style='width:441.55pt;border-top:none;border-left:none;
    border-bottom:solid #D9D9D9 1.0pt;border-right:solid #D9D9D9 1.0pt;
    padding:6.0pt 9.75pt 6.0pt 9.75pt'>
    <p class=MsoNormal align=left style='text-align:left'><span style='font-family:
    "Arial","sans-serif";color:#333333'>错误码，<span lang=EN-US>success </span>表示成功<span
    lang=EN-US>error </span>表示失败</span></p>
    </td>
  </tr>
  <tr>
    <td width=102 style='width:76.3pt;border:solid #D9D9D9 1.0pt;border-top:none;
    padding:6.0pt 9.75pt 6.0pt 9.75pt'>
    <p class=MsoNormal align=left style='text-align:left'><span lang=EN-US
    style='font-size:9.0pt;font-family:"Helvetica","sans-serif";color:#505050;
    background:white'>msg</span></p>
    </td>
    <td width=92 style='width:69.3pt;border-top:none;border-left:none;border-bottom:
    solid #D9D9D9 1.0pt;border-right:solid #D9D9D9 1.0pt;padding:6.0pt 9.75pt 6.0pt 9.75pt'>
    <p class=MsoNormal align=left style='text-align:left'><span style='font-family:
    "Arial","sans-serif";color:#333333'>是</span></p>
    </td>
    <td width=107 style='width:80.25pt;border-top:none;border-left:none;
    border-bottom:solid #D9D9D9 1.0pt;border-right:solid #D9D9D9 1.0pt;
    padding:6.0pt 9.75pt 6.0pt 9.75pt'>
    <p class=MsoNormal align=left style='text-align:left'><span lang=EN-US
    style='font-family:"Arial","sans-serif";color:#333333'>string</span></p>
    </td>
    <td width=589 style='width:441.55pt;border-top:none;border-left:none;
    border-bottom:solid #D9D9D9 1.0pt;border-right:solid #D9D9D9 1.0pt;
    padding:6.0pt 9.75pt 6.0pt 9.75pt'>
    <p class=MsoNormal align=left style='text-align:left'><span style='font-family:
    "Arial","sans-serif";color:#333333'>错误消息</span></p>
    </td>
  </tr>
  </table>

<p class=MsoNormal><span lang=EN-US>&nbsp;</span></p>

</div>

  </div>
</template>
<script>
import api from "../../server/api.js";
export default {
  name: "msgRecord",
  data() {
    return {
      pageSize: 10, //当前显示条数
      pageNum: 1, //当前页数
      total: 0, //总数
      mdgRecordData: []
    };
  },
  created() {
    this.getMsgRecord();
  },
  methods: {
    getMsgRecord() {
      //获取列表
      let data = {
        start: this.pageNum,
        length: this.pageSize
        // "startTime":
        // "endTime":
        // "userName":
        // "smsStatus":
        // "userPhone":
      };
      api.getRecordList({ data: data }).then(res => {
        if (res.status == "success") {
          this.mdgRecordData = res.data.resultList;
          this.total = res.data.count;
        }
      });
    },
    sizeChange(v) {
      //切换显示条数
      this.pageSize = v;
      this.getMsgRecord();
    },
    currentChange(v) {
      //切换页数
      this.pageNum = v;
      this.getMsgRecord();
    }
  },
  components: {}
};
</script>





// WEBPACK FOOTER //
// src/view/apidoc/sendMsg.vue